import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { messageService } from '../../api';
import './Message.css';
import Header from '../Header/Header';
import Footer from '../footer/Footer';

const Message = () => {
    const navigate = useNavigate();
    const location = useLocation();
    
    const destinataireIdFromProps = location.state?.destinataireId;
    const destinataireNameFromProps = location.state?.destinataireName;
    
    const [formData, setFormData] = useState({
        contenu: '',
        destinataire_id: destinataireIdFromProps || ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [unauthenticated, setUnauthenticated] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setUnauthenticated(false);
        
        try {
            await messageService.send(
                formData.contenu, 
                formData.destinataire_id
            );
            
            setSuccess(true);
            setFormData({ contenu: '', destinataire_id: '' });
            
            setTimeout(() => {
                navigate('/annonces');
            }, 2000);
            
        } catch (err) {
            if (err.response && err.response.status === 401) {
                setUnauthenticated(true);
            } else {
                setError(err.message || 'Erreur lors de l\'envoi du message');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="message-page">
            <Header />
            
            <div className="message-content">
                <div className="message-card">
                    <h2>Envoyer un message{destinataireNameFromProps && ` à ${destinataireNameFromProps}`}</h2>
                    
                    {error && <div className="alert alert-danger">{error}</div>}
                    {unauthenticated && (
                        <div className="alert alert-warning unauthenticated-alert">
                            <p>Vous devez être connecté pour envoyer un message</p>
                            <div className="auth-actions">
                                <button 
                                    className="login-btn"
                                    onClick={() => navigate('/connexion')}
                                >
                                    Se connecter
                                </button>
                                <button 
                                    className="register-btn"
                                    onClick={() => navigate('/inscription')}
                                >
                                    Créer un compte
                                </button>
                            </div>
                        </div>
                    )}
                    {success && <div className="alert alert-success">Message envoyé avec succès!</div>}
                    
                    <form onSubmit={handleSubmit}>
                        <input
                            type="hidden"
                            name="destinataire_id"
                            value={formData.destinataire_id}
                        />
                        
                        <div className="form-group">
                            <label>Veuillez vous connecter au préalable avant d'envoyer un message</label>
                            
                            <textarea
                                name="contenu"
                                value={formData.contenu}
                                onChange={handleChange}
                                required
                                maxLength="1000"
                                placeholder="Écrivez votre message ici..."
                                className="message-textarea"
                                disabled={unauthenticated}
                            />
                        </div>
                        
                        <div className="button-group">
                            <button 
                                type="submit" 
                                className="send-btn"
                                disabled={loading || unauthenticated}
                            >
                                {loading ? 'Envoi en cours...' : 'Envoyer le message'}
                            </button>
                            <button 
                                type="button" 
                                className="cancel-btn"
                                onClick={() => navigate(-1)}
                            >
                                Annuler
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            
            <Footer />
        </div>
    );
};

export default Message;